import React, { useEffect, useRef, useState } from 'react';
import "quill-mention";
import ReactQuill from 'react-quill';
import Dictate from './Dictate';
import Augnito from './Augnito';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../redux/store";
import { pathology_options, toolbarOptions, placeholder } from '../../constant';
import { useSelector, useDispatch } from 'react-redux';
import { requestAddPatient } from "../../redux/OsteroCheckSlice";
import { setPathologyData,setHtmlString, } from '../../redux/Report-builder/ReportBuilder';
import { removeReport, resetContent, flipChatQuestion, replaceAdditionalImpression, replaceAddtionalObservation } from '../../redux/Report-builder/ReportContents';
import { resetMessage, addMessage } from '../../redux/Report-builder/ChatMessages';
import { addPathology, removePathology, resetSelectedPathology, flipIsReportable, flipIsGenerating } from '../../redux/Report-builder/SelectedPathologies';
import { setCursorPosition, setSizeInput, setTextArea, setDataFromAugnito, augnitoStartListening, augnitoStopListening, whisperStopListening, whisperStartListening } from '../../redux/Report-builder/Augnito';
import {
  streamFullReportContent, streamPathologyContent, copyHTMLToClipboard, updateObservationVariables,
  getOptionFromReportContents, findVariableProperty, checkForEligibleAdditionalQuestion
} from '../../utils/helper'
import { updatePathologyFormData, resetPathologyFormData } from '../../redux/Report-builder/PathologyFormData';
import { _getProperty } from 'gsap/gsap-core';
import { TbClick } from "react-icons/tb";
import { TypeAnimation } from 'react-type-animation';




function Editor({ onSendMessageStream }) {
  const augnitoData = useSelector((state) => state.augnito.augnitoData);
  const augnitoTextValue = useSelector((state) => state.augnito.valueFromAugntio)
  const augnitoState = useSelector((state) => state.augnito.augnitoState);
  const augnitoStateConnection = useSelector((state) => state.augnito.isListening);
  const whisperState = useSelector((state) => state.augnito.isWhisper)
  const whisperData = useSelector((state) => state.augnito.whisperData);
  const formData = useSelector((state) => state.reportBuilder.formData);
  const patientData=useSelector((state)=>state.reportBuilder.jsonData)
  const pathologyDataDemo=useSelector((state)=>state.reportBuilder.pathologyData)
  const htmlString=useSelector((state)=>state.reportBuilder.htmlString)
  const userleveraccess = useSelector((state) => state?.user?.isEnabled)
  const report = useSelector((state) => state.OsteroCheck.report);
  const navigate=useNavigate();

  // const userData = useSelector((state) => state.user.user);
  const { reportContents,
    selectedModStudyValue,
    selectedPathologies,
    isReportable,
    isGenerating,
    pathologyFormData,
    quillDictate,
    sizeInputDictate, //For size textbox value
    isChatBotActive,
  } = useSelector(state => ({
    reportContents: state.reportContents.reportContents,
    selectedModStudyValue: state.selectedModStudy.selectedModStudyValue,
    selectedPathologies: state.selectedPathologies.selectedPathologies,
    isReportable: state.selectedPathologies.isReportable,
    isGenerating: state.selectedPathologies.isGenerating,
    pathologyFormData: state.pathologyFormData.pathologyFormData,
    quillDictate: state.augnito.quillDictate,
    sizeInputDictate: state.augnito.sizeInputDictate,
    isChatBotActive: state.reportContents.isChatBotActive,
  }));

  const dispatch = useDispatch();
  const appDispatch=useAppDispatch();
  const isOptionClickedRef = useRef(false);
  const cursorRef = useRef(null);
  let pathologyForSearchRef = useRef({});


  const [isAIReportable, setIsAIReportable] = useState(false);
  const [isMentionActive, setIsMentionActive] = useState(false);
  const [selectedLocalPathologies, setSelectedLocalPathologies] = useState([]);
  const [autoAugnitoState, setautoAugnitoState] = useState(false);
  const [augnitoStateValue, setAugnitostateValue] = useState('')
  const [augnitoEditorState, setaugntioEditorState] = useState(false)
  const [loadingWidth, setLoadingWidth] = useState(0);

  const [showCopiedTextObservation, setShowCopiedTextObservation] = useState(false);
  const [showCopiedTextImpression, setShowCopiedTextImpression] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const quillRef = useRef(null);
  const [showForm, setShowForm] = useState(false);
  const [formPosition, setFormPosition] = useState({ left: 0, top: 0 });
  const [currentLabel, setCurrentLabel] = useState('');
  const [selectedPathologyOnClick, setSelectedPathologyOnClick] = useState('');
  const [colorRangeIndex, setColorRangeIndex] = useState(0);
  const [startwriting, setstartwriting] = useState(false)
  const [editorContent, setEditorContent] = useState('');


  useEffect(() => {
    const quill = quillRef.current.getEditor();
    quill.on('selection-change', handleSelectionChange);
    quill.on('text-change', (delta, oldDelta, source) => {
      if (source === 'user') {
        const regex = /@(\w+)/g;
        const match = regex.exec(quill.getText());

        if (match) {
          let pathologyForSearch = []
          pathology_options[selectedModStudyValue].forEach(element => {
            if (element.includes(match[1])) {
              pathologyForSearch.push(element);
            }
          });
          pathologyForSearchRef.current.pathologyForSearch = pathologyForSearch;
          pathologyForSearchRef.current.index = match.index;
          pathologyForSearchRef.current.value = match[1];

          if (!pathologyForSearchRef.current.pathologyForSearch.length) {
            setIsMentionActive(false);
            return;
          }

          const bounds = quill.getBounds(match.index);
          const editorContainer = quill.container.getBoundingClientRect();
          const formLeft = bounds.left + editorContainer.left;
          const formTop = bounds.bottom + editorContainer.top;
          setFormPosition({ left: formLeft, top: formTop });
          setIsMentionActive(true);
          return;
        }
      }
    });

  }, []);



  const setIsOptionClicked = (value) => {
    isOptionClickedRef.current = value;
    handleSelectionChange(null)
  }

  //it gives the pathology name using @
  const hamdleSelectFromMention = (value) => {
    if (pathologyForSearchRef.current?.pathologyForSearch.length) {
      quillRef.current.getEditor().deleteText(pathologyForSearchRef.current.index, pathologyForSearchRef.current.value.length);
      handleOnPathologySelect(value);
    }
    setIsMentionActive(false);
  }

  useEffect(() => {
    const quill = quillRef.current.getEditor();
    if (quillDictate.length) {

      quill.insertText(cursorRef.current, quillDictate);
      cursorRef.current += quillDictate.length

    }

  }, [quillDictate]);

  // it tracks the cursor where it's present in the editor currently.
  const handleSelectionChange = (range) => {
    setIsMentionActive(false);
    if (range) {
      const quill = quillRef.current.getEditor();
      const clickedIndex = range.index;
      const text = quill.getText();
      const labelRegex = /_\w+/g;
      let match;
      while ((match = labelRegex.exec(text)) !== null) {
        const labelStart = match.index;
        const labelEnd = match.index + match[0].length;
        if (clickedIndex >= labelStart && clickedIndex <= labelEnd) {

          const currentLabel = text.slice(labelStart, labelEnd);
          setCurrentLabel(currentLabel);
          const bounds = quill.getBounds(range.index);
          const editorContainer = quill.container.getBoundingClientRect();

          const formLeft = bounds.left + editorContainer.left * 1.05;
          const formTop = bounds.bottom + editorContainer.top * 1.01;
          setFormPosition({ left: formLeft, top: formTop });
          setShowForm(true);
          cursorRef.current = null

          dispatch(setCursorPosition('sizeInput'))
          setIsOptionClicked(true);

          const blot = quill.getLeaf(range.index)[0];
          const paragraphBlot = blot.parent;
          const paragraphElement = paragraphBlot.domNode;
          const paragraphId = paragraphElement.id;
          setSelectedPathologyOnClick(paragraphId.replace('obs-', ''))
          return;
        }
        else {
          setIsOptionClicked(false)
        }
      }
      cursorRef.current = range.index
      dispatch(setCursorPosition('quill'))

    }

    if (isOptionClickedRef.current) return;
    setShowForm(false);
  };

  // it gives the report content after selecting the pathology in html
  useEffect(() => {
    if (!isChatBotActive) {
      const responseHtml = streamPathologyContent(reportContents, null);
      quillRef.current.getEditor().root.innerHTML = responseHtml;
    }
  }, [reportContents]);




  //it executes when the button is clicked within the label
  const handleLabelSelect = (label) => {
    const quill = quillRef.current.getEditor();
    const labelStartIndex = quill.getText().indexOf(currentLabel);
    const labelEndIndex = labelStartIndex + currentLabel.length;
    const content = reportContents.find((c) => c.pathology === selectedPathologyOnClick);

    if (content.observation_init.includes(currentLabel)) {
      let impression_init_copy = content.impression_init
      let observation_init_copy = content.observation_init

      if (Object.keys(pathologyFormData).length) {
        if (pathologyFormData[selectedPathologyOnClick]) {
          for (const [key, value] of Object.entries(pathologyFormData[selectedPathologyOnClick])) {
            if (key !== currentLabel.replace('_', '')) {
              impression_init_copy = impression_init_copy.replace(new RegExp(`\\b_${key}\\b`, 'g'), value);
              observation_init_copy = observation_init_copy.replace(new RegExp(`\\b_${key}\\b`, 'g'), value);
            }
          }
        }
      }

      impression_init_copy = impression_init_copy.replace(new RegExp(`\\b${currentLabel}\\b`, 'g'), label);
      observation_init_copy = observation_init_copy.replace(new RegExp(`\\b${currentLabel}\\b`, 'g'), label);

      dispatch(replaceAdditionalImpression({
        'pathology': selectedPathologyOnClick,
        'impression': impression_init_copy
      }))
      dispatch(replaceAddtionalObservation({
        'pathology': selectedPathologyOnClick,
        'observation': observation_init_copy
      }))

    }

    dispatch(updatePathologyFormData({ key: currentLabel.replace('_', ''), value: label, pathology: selectedPathologyOnClick }));

    const updatedPathologyFormData = {
      ...pathologyFormData,
      [selectedPathologyOnClick]: {
        ...pathologyFormData[selectedPathologyOnClick],
        [currentLabel.replace('_', '')]: label,
      },
    }

    const additionalQuestionsMessage = checkForEligibleAdditionalQuestion(reportContents, updatedPathologyFormData)

    if (additionalQuestionsMessage) {

      setTimeout(() => {
        dispatch(flipChatQuestion(true));
        dispatch(addMessage({ 'sender': 'Bot', 'text': additionalQuestionsMessage, 'question': true }));
      }, 500);

    }

    quill.deleteText(labelStartIndex, labelEndIndex - labelStartIndex);
    quill.insertText(labelStartIndex, label);

    setShowForm(false);
  };


  const handleMultipleSelect = (e) => {
    e.preventDefault();
    const selectedLabels = Array.from(e.target.elements).filter((element) => element.type === 'checkbox' && element.checked).map((element) => element.value).join(', ');
    if (selectedLabels.length) {
      handleLabelSelect(selectedLabels);
    }
  }


  useEffect(() => {

    let lastElement;
    const restOfReportContents = [];

    reportContents.forEach(item => {
      item.isLast ? lastElement = item : restOfReportContents.push(item);
    });
    if (!isAIReportable) {
      const responseHtml = streamPathologyContent(restOfReportContents, lastElement);
      quillRef.current.getEditor().root.innerHTML = responseHtml;

      if (!isReportable) return;

      if (lastElement && document.getElementById(`obs-${lastElement['pathology']}`)) {
        let index = 0;

        const lastElement_observation = document.getElementById(`obs-${lastElement['pathology']}`).innerHTML

        const intervalId = setInterval(() => {
          if (index < lastElement_observation + 3) {
            document.getElementById(`obs-${lastElement['pathology']}`).innerHTML = lastElement_observation.slice(0, index);
          } else {
            clearInterval(intervalId);
            dispatch(flipIsGenerating(false));

            if (lastElement && document.getElementById(`imp-${lastElement['pathology']}`)) {
              let index_x = 0;
              const intervalId_x = setInterval(() => {
                if (index_x < lastElement['impression'].length + 3) {
                  document.getElementById(`imp-${lastElement['pathology']}`).innerHTML = lastElement['impression'].slice(0, index_x);
                } else {
                  clearInterval(intervalId_x);
                }
                index_x += 3;
              }, process.env.REACT_APP_STREAMING_OBS);
            }
          }
          index += 3;
        }, process.env.REACT_APP_STREAMING_OBS);

      }

    } else {
      const responseHtml = streamFullReportContent(reportContents, selectedModStudyValue);

      let index = 0;
      const intervalId = setInterval(() => {
        if (index < responseHtml.length + 5) {
          quillRef.current.getEditor().root.innerHTML = responseHtml.slice(0, index);
        } else {
          clearInterval(intervalId);
          dispatch(flipIsGenerating(false));
          setIsAIReportable(false);
        }
        index += 5;
      }, process.env.REACT_APP_STREAMING_WHOLE);
    }

    dispatch(flipIsReportable(false));
  }, [isReportable]);

  //it returns the full report content from the backend
  useEffect(() => {
    const newReportContents = [...reportContents];

    for (const [index, pathology] of selectedLocalPathologies.entries()) {
      if (newReportContents.some(item => item.pathology === pathology)) {
        continue;
      }

      fetch(`${process.env.REACT_APP_BIONIC_BACKEND_API}/api/get-observation?pathology=${pathology}&mod_study=${selectedModStudyValue}`, {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_BIONIC_BACKEND_API_TOKEN}`
        }
      }).then(async (response) => {
        const data = await response.json();
        data.forEach(iter => {

          const impression = iter['impression'] === '-' ? '' : iter['impression'];
          const isLast = index === selectedLocalPathologies?.length - 1;

          newReportContents.push({
            pathology,
            observation_init: iter['observation'],
            observation: iter['observation'],
            variable: iter['variable'],
            question: iter['question'],
            impression_init: impression,
            impression,
            isLast,
            isToBeQuestioned: iter['variable'] && Object.keys(iter['variable']).length > 0
          });
        });

        if (newReportContents.length > 1) {
          let updatedReportContent = { ...newReportContents[newReportContents.length - 2], isLast: false };
          newReportContents.splice(newReportContents.length - 2, 1, updatedReportContent);
        }
        dispatch(resetContent(newReportContents));
        dispatch(addPathology(pathology));
      })
      // .catch((e) => {
      //   throw new Error(`HTTP error! Status: ${e}`);
      // });
    }
  }, [selectedLocalPathologies]);

  //it extracts placeholder value as list of dict (type,key,value). it executes after the full report is clicked
  const extractPlaceholder = (data) => {
    for (const key in data) {
      if (data[key].place_holder === 'true') {
        return data[key].key;
      }
    }
  }

  //full report functionality
  const handleOnFullReportClick = () => {
    let tempReportContents = [...reportContents];

    // console.log("tempreportcontents", tempReportContents)

    const textBlocks = quillRef.current.getEditor().root.querySelectorAll('p');
    tempReportContents = tempReportContents.map(item => {
      const elements = Array.from(textBlocks).filter(block => block.getAttribute('id') === 'obs-' + item.pathology);

      const addtionalPlaceholder = pathologyFormData[item.pathology]?.[extractPlaceholder(item?.question)]
      if (addtionalPlaceholder) {
        return elements.length > 0 ? {
          ...item,
          observation: elements.map(element => element.innerHTML).join('\n'),
          pathology: item.pathology,
          organ: placeholder?.[selectedModStudyValue]?.[extractPlaceholder(item?.question)][addtionalPlaceholder],
          placeholder: item.pathology + ' - ' + addtionalPlaceholder,
        } : {
          ...item,
          pathology: item.pathology,
          organ: placeholder?.[selectedModStudyValue]?.[extractPlaceholder(item?.question)][addtionalPlaceholder],
          placeholder: item.pathology + ' - ' + addtionalPlaceholder,
        };

      }
      return elements.length > 0 ? { ...item, observation: elements.map(element => element.innerHTML).join('\n') } : item;
    });
    tempReportContents = tempReportContents.map(item => {
      const elements = Array.from(textBlocks).filter(block => block.getAttribute('id') === 'imp-' + item.pathology);
      return elements.length > 0 ? { ...item, impression: elements.map(element => element.innerHTML).join('\n') } : item;
    });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${process.env.REACT_APP_BIONIC_BACKEND_API_TOKEN}`);

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify({ reportContents: tempReportContents, mod_study: selectedModStudyValue }),
      redirect: 'follow'
    };

    fetch(`${process.env.REACT_APP_BIONIC_BACKEND_API}/api/refine-report`, requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(result => {
        if (!Array.isArray(result)) {
          throw new Error("[Slate] initialValue is invalid! Expected a list of elements but got: undefined");
        }
        tempReportContents.forEach(tempContent => {
          const resultContent = result.find(content => content.pathology === tempContent.pathology);
          // console.log("contentineditor",resultContent)
          if (resultContent) {
            if (tempContent?.placeholder) {
              const updatedContent = {
                ...tempContent,
                organ: 'ab ' + tempContent.organ
              };
              Object.assign(resultContent, updatedContent);
            }
            else {
              Object.assign(resultContent, tempContent);
            }
          }
        });

        dispatch(resetContent(result));
        const pathologyValues = result.filter(item => item.pathology !== 'normal').map(item => item.pathology);
        dispatch(setPathologyData(pathologyValues));
       

        dispatch(flipIsReportable(true));

      })


    dispatch(flipIsGenerating(true));
    setIsAIReportable(true);
  };


  //clear button functionality
  const handleOnClearClick = () => {
    dispatch(resetMessage());
    dispatch(resetContent([]));
    dispatch(resetSelectedPathology([]));
    dispatch(resetPathologyFormData({}));
    setSelectedLocalPathologies([]);
    const responseHtml = streamPathologyContent([], null);
    quillRef.current.getEditor().setContents(responseHtml);
  };

  //pathology selection using the textbox
  const handleOnPathologySelect = (selectedPathology) => {
    if (!selectedPathologies || !selectedPathologies.includes(selectedPathology)) {
      dispatch(flipIsGenerating(true));
      dispatch(addMessage({ 'text': selectedPathology, 'sender': 'You' }));

      let reportContentUpdated = reportContents.map(content => {
        if (content.pathology !== 'normal') {
          return content;
        }
      });
      reportContentUpdated = reportContentUpdated.filter(content => content !== undefined);
      dispatch(resetContent(updateObservationVariables(reportContentUpdated, pathologyFormData)));
      setSelectedLocalPathologies([...selectedLocalPathologies, selectedPathology]);
    }
    setInputValue('');
  };
  // delete pathology functionality
  const handleOnDeletePathology = (pathologyToSelect) => {
    dispatch(removePathology(pathologyToSelect));
    dispatch(removeReport(pathologyToSelect));
  };

  const variableType = findVariableProperty(reportContents, selectedPathologyOnClick, currentLabel, 'type');


  const handleToggleDictateTooltip = () => {
    if (!augnitoState) {
      setAugnitostateValue("on")
    }
    else {
      setAugnitostateValue("off")
    }
  };

  const findColorRange = (quill, color) => {
    let ranges = [];
    if (quill) {
      quill.scroll.descendants(function (blot) {
        if (blot.statics.blotName === 'inline' && blot.formats().background === color) {
          let index = blot.offset(quill.scroll);
          ranges.push({ index: index, length: blot.length() });
        }
      });
    }
    return ranges;
  };

  const logColorRanges = () => {
    const quill = quillRef.current?.getEditor();
    const searchColor = '#f5f7a6';
    const colorRanges = findColorRange(quill, searchColor);
    let currentIndex = 0;

    const handleNextRange = () => {
      if (currentIndex < colorRanges.length) {
        handleSelectionChange(colorRanges[currentIndex]);
        currentIndex++;
      }
    };

    handleNextRange();
  };

  //select the pathology using the augnito
  const handleStreamText = (streamText) => {
    // console.log("streamText:", streamText, "length:", streamText.length);

    const trimmedText = streamText.trim().toLowerCase();
    // console.log("trimmedText:", trimmedText, "length:", trimmedText.length);

    // if (trimmedText === 'start listening') {
    //   dispatch(augnitoStartListening());
    //   setaugntioEditorState(false)
    //   setautoAugnitoState(true);
    // } else if (trimmedText === 'close listening') {
    //   setautoAugnitoState(false);
    // } 
    if (trimmedText === 'stop') {
      dispatch(whisperStartListening())
      dispatch(augnitoStartListening())
    }

    else {
      dispatch(setDataFromAugnito(streamText));
    }

  };

  useEffect(() => {
    const trimmedText = whisperData.trim().toLowerCase();
    const editor = quillRef.current.getEditor();
    const editorElement = editor.root;

    if (trimmedText === 'hey bionic') {
      setautoAugnitoState(true)
      quillRef.current?.blur();
      dispatch(setCursorPosition('textArea'))
    }
    else if (trimmedText === 'add line') {
      quillRef.current.focus();
      editorElement.classList.add('caret-focused');
      setstartwriting(true)
      setautoAugnitoState(false);
      dispatch(whisperStopListening())
    }
    else if (trimmedText === 'generate report') {
      setautoAugnitoState(false)
    }
    else if (trimmedText === 'full report') {
      handleOnFullReportClick();
      // dispatch(whisperStopListening())
    }


    if (!whisperState) {
      setstartwriting(false)
    }
  }, [whisperData])


  useEffect(() => {
    if (patientData) {
      
      // sessionStorage.setItem('patientData', JSON.stringify(patientData));
    } else {
      console.log('patientData is null or undefined');
    }

    if (formData) {
      sessionStorage.setItem('formdatademo', JSON.stringify(formData));
    } else {
      console.log('formData is null or undefined');
    }

    const storedPatientData = JSON.parse(sessionStorage.getItem('patientData'));
      const storedFormData = JSON.parse(sessionStorage.getItem('formdatademo'));
  }, [patientData, formData]);


  const handleReport = async () => {
    try {
      const htmlString = quillRef.current ? quillRef.current.getEditor().root.innerHTML : '';
      const storedPatientData = JSON.parse(sessionStorage.getItem('patientData'));
      const storedFormData = JSON.parse(sessionStorage.getItem('formdatademo'));


      if (!storedPatientData || !storedFormData) {
        console.error('No data found in sessionStorage');
        return;
      }

      const result = await appDispatch(requestAddPatient({
        patient_data: storedPatientData,
        formData: storedFormData,
        pathologyData: pathologyDataDemo,
        htmlString: htmlString
      }));

      
      if (requestAddPatient.fulfilled.match(result)) {

        sessionStorage.removeItem('patientData');
        sessionStorage.removeItem('formdatademo'); 
        sessionStorage.removeItem('selectedModStudy'); 
        sessionStorage.removeItem('selectedDropdownValue');
        sessionStorage.removeItem('studyId');  
        dispatch(resetMessage());
        dispatch(resetContent([]));
        dispatch(resetSelectedPathology([]));
        dispatch(resetPathologyFormData({}));
        setSelectedLocalPathologies([]);
        const responseHtml = streamPathologyContent([], null);
        quillRef.current.getEditor().setContents(responseHtml);
        navigate("/reports");
      } else if (requestAddPatient.rejected.match(result)) {
        console.error('Failed to add patient data:', result.payload);
      }
    } catch (error) {
      console.error('Error in handleReport:', error);
    }
  };


  const handleEditorFocus = () => {
    setstartwriting(true)
  };

  useEffect(() => {
    if (report.loading) {
      setTimeout(() => {
        if (loadingWidth < 96) {
          setLoadingWidth(loadingWidth + 4);
        }
      }, 500);
    }
  }, [report.loading, loadingWidth]);



  return (
    <div className=' mr-2'>
      {report.loading && (
     <div className="absolute inset-0 flex flex-col items-center justify-center z-20 bg-[#e7e7e7] bg-opacity-5 backdrop-filter backdrop-blur-sm">
     <iframe src="https://lottie.host/embed/1329de50-00a6-4ecf-8436-23a4366023ef/9c9C0i38kl.json" className="w-1/3 h-1/4"></iframe>
     <TypeAnimation
      sequence={[
        'Generating report...',
        1000,
        'Generating report',
        200,
        'Generating report.',
        200,
        'Generating report..',
        200,
        'Generating report...',
        1000,
      ]}
      wrapper="span"
      cursor={true}
      repeat={Infinity}
      style={{ fontSize: '1.5em', display: 'inline-block', color: '#82a6d8' }}
    />
   </div>
      )}
     
      <div className='h-[6vh] pt-3 overflow-x-auto scrollbar-thumb-blue scrollbar-thumb-rounded scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch ' >
        <div className="flex flex-nowrap gap-3  whitespace-nowrap">
          {selectedPathologies?.length > 0 ? selectedPathologies.map(label => (
            <span key={label} className={`flex items-center text-black text-l font-semibold px-2.5 py-1.5 rounded bg-blue-50`} >
              {label.length > 17 ? label.substring(0, 17) + ".." : label}
              <button onClick={() => handleOnDeletePathology(label)} className="ml-3 text-black-500">
                &times;
              </button>
            </span>
          )) : <div className=""></div>}
        </div>
      </div>
      <div className="border-2 rounded-2xl " style={{ boxShadow: '0px 2px 2px 0px #d3d3d3' }}>
        <div className="flex flex-grow py-3 rounded-t-2xl space-x-1.5 bg-blue-50 justify-center">

          {/* <div className="w-[25vh]">
            <input
              type="text"
              value={inputValue}
              onChange={(event) => setInputValue(event.target.value)}
              disabled={isGenerating}
              style={isGenerating ? { filter: "blur(1px)" } : {}}
              placeholder="Add pathology"
              className="w-full px-3 py-2 rounded-2xl shadow-sm focus:outline-none"
            />
            {inputValue && (
              <ul className="absolute z-10 w-[40vh] bg-white border border-gray-300 mt-1 rounded shadow-lg max-h-60 overflow-auto">
                {pathology_options[selectedModStudyValue]
                  .filter(option => option.toLowerCase().includes(inputValue.toLowerCase()))
                  .map(option => (
                    <li key={option}
                      onClick={() => handleOnPathologySelect(option)}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer">
                      {option}
                    </li>
                  ))}
              </ul>
            )}
          </div> */}
          <div className="flex space-x-4.5">
            <div className='flex space-x-3.5 h-8 mt-1'>
              {/* <CustomDropdown className="" /> */}
              <button id="stream-button" class="bg-white border border-blue-700  font-semibold py-2 px-3 rounded inline-flex items-center"
                onClick={handleOnFullReportClick}
                disabled={isGenerating}
                style={isGenerating ? { filter: "blur(1px)" } : {}}>
                <svg width="28" height="28" viewBox="0 0 11 11" fill="black" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.86748 4.80655V3.97992H8.04084V3.15328C8.04019 2.93424 7.95289 2.72436 7.798 2.56948C7.64312 2.41459 7.43324 2.32729 7.2142 2.32664H6.38757V1.5H5.56093V2.32664H4.73429V1.5H3.90765V2.32664H3.08101C2.86197 2.32729 2.6521 2.41459 2.49721 2.56948C2.34233 2.72436 2.25503 2.93424 2.25437 3.15328V3.97992H1.42773V4.80655H2.25437V5.63319H1.42773V6.45983H2.25437V7.28647C2.25503 7.50551 2.34233 7.71539 2.49721 7.87027C2.6521 8.02515 2.86197 8.11245 3.08101 8.11311H3.90765V8.93975H4.73429V8.11311H5.56093V8.93975H6.38757V8.11311H7.2142C7.43324 8.11245 7.64312 8.02515 7.798 7.87027C7.95289 7.71539 8.04019 7.50551 8.04084 7.28647V6.45983H8.86748V5.63319H8.04084V4.80655H8.86748ZM7.2142 7.28647H3.08101V3.15328H7.2142V7.28647Z" fill="black" />
                  <path d="M4.88473 3.56677H4.32882L3.49805 6.87333H3.92253L4.11431 6.09835H5.07155L5.25837 6.87333H5.69732L4.88473 3.56677ZM4.1701 5.76728L4.59086 3.95943H4.60988L5.01617 5.76728H4.1701ZM6.07633 3.56677H6.48965V6.87333H6.07633V3.56677Z" fill="black" />
                </svg>
                <span className="text-sm text-black font-normal">Full&nbsp;Report</span>
              </button>

              {/* <button id="copy-button-observation" class="bg-white border border-blue-500 font-semibold py-2 px-3 rounded inline-flex items-center"
                onClick={handleCopyClickObservation}
                disabled={isGenerating}
                style={isGenerating ? { filter: "blur(1px)" } : {}}>
                <svg width="28" height="28" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1664_2612)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.6203 1.36865H4.30832C3.71379 1.36865 3.24282 1.36865 2.87439 1.41814C2.49528 1.46925 2.18831 1.57664 1.94604 1.8186C1.70408 2.06087 1.59669 2.36784 1.54558 2.74695C1.49609 3.1157 1.49609 3.58634 1.49609 4.18088V6.1398C1.4961 6.42879 1.59926 6.70829 1.787 6.92799C1.97474 7.14769 2.23474 7.29317 2.52019 7.33824C2.56451 7.58537 2.65023 7.79627 2.82166 7.96803C3.01639 8.16276 3.26158 8.24621 3.5527 8.28568C3.83314 8.3232 4.18993 8.3232 4.63211 8.3232H5.63809C6.08027 8.3232 6.43706 8.3232 6.7175 8.28568C7.00862 8.24621 7.25381 8.16276 7.44854 7.96803C7.64327 7.7733 7.72672 7.52812 7.76618 7.237C7.80371 6.95655 7.80371 6.59977 7.80371 6.15759V4.50467C7.80371 4.06249 7.80371 3.7057 7.76618 3.42526C7.72672 3.13414 7.64327 2.88895 7.44854 2.69422C7.27678 2.52278 7.06588 2.43706 6.81875 2.39275C6.77368 2.10729 6.6282 1.8473 6.4085 1.65956C6.18879 1.47182 5.90929 1.36866 5.6203 1.36865ZM6.30929 2.34585C6.2601 2.20223 6.16724 2.07758 6.04369 1.98936C5.92015 1.90114 5.77211 1.85376 5.6203 1.85385H4.32643C3.70958 1.85385 3.27161 1.8545 2.93876 1.89914C2.61367 1.94281 2.42606 2.02497 2.28924 2.16179C2.15241 2.29862 2.07025 2.48623 2.02658 2.81164C1.98194 3.14416 1.98129 3.58214 1.98129 4.19899V6.1398C1.9812 6.2916 2.02858 6.43964 2.1168 6.56319C2.20502 6.68673 2.32967 6.77959 2.47329 6.82878C2.4665 6.63146 2.4665 6.40827 2.4665 6.15759V4.50467C2.4665 4.06249 2.4665 3.7057 2.50434 3.42526C2.54316 3.13414 2.62726 2.88895 2.82166 2.69422C3.01639 2.49949 3.26158 2.41604 3.5527 2.3769C3.83314 2.33905 4.18993 2.33905 4.63211 2.33905H5.63809C5.88878 2.33905 6.11197 2.33905 6.30929 2.34585ZM3.16454 3.03774C3.25414 2.94814 3.37964 2.88992 3.61739 2.8579C3.86129 2.82523 4.1854 2.82458 4.64958 2.82458H5.61998C6.08415 2.82458 6.40794 2.82523 6.65249 2.8579C6.88991 2.88992 7.01542 2.94847 7.10502 3.03774C7.19462 3.12734 7.25284 3.25285 7.28486 3.4906C7.31753 3.73449 7.31818 4.05861 7.31818 4.52278V6.14012C7.31818 6.60429 7.31753 6.92809 7.28486 7.17263C7.25284 7.41005 7.19429 7.53556 7.10502 7.62516C7.01542 7.71476 6.88991 7.77298 6.65216 7.80501C6.40794 7.83768 6.08415 7.83832 5.61998 7.83832H4.64958C4.1854 7.83832 3.86129 7.83768 3.61707 7.80501C3.37964 7.77298 3.25414 7.71443 3.16454 7.62516C3.07494 7.53556 3.01671 7.41005 2.98469 7.1723C2.95202 6.92808 2.95137 6.60429 2.95137 6.14012V4.52278C2.95137 4.05861 2.95202 3.73449 2.98469 3.49027C3.01671 3.25285 3.07526 3.12734 3.16454 3.03774Z" fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1664_2612">
                      <rect width="7.76322" height="7.76322" fill="black" transform="translate(0.767578 0.964233)" />
                    </clipPath>
                  </defs>
                </svg>
                {showCopiedTextObservation ? <span className="ml-3 mr-2.5 text-sm text-balck">Copied !!</span> : <span className="text-sm">Observation</span>}
                {<span className="text-sm text-black">Copy</span>}
              </button> */}

              {/* <button id="copy-button-impression" class="bg-white border border-blue-500 font-semibold py-2 px-3 rounded inline-flex items-center"
                onClick={handleCopyClickImpression}
                disabled={isGenerating}
                style={isGenerating ? { filter: "blur(1px)" } : {}}>
                <svg width="28" height="28" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_1664_2612)">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.6203 1.36865H4.30832C3.71379 1.36865 3.24282 1.36865 2.87439 1.41814C2.49528 1.46925 2.18831 1.57664 1.94604 1.8186C1.70408 2.06087 1.59669 2.36784 1.54558 2.74695C1.49609 3.1157 1.49609 3.58634 1.49609 4.18088V6.1398C1.4961 6.42879 1.59926 6.70829 1.787 6.92799C1.97474 7.14769 2.23474 7.29317 2.52019 7.33824C2.56451 7.58537 2.65023 7.79627 2.82166 7.96803C3.01639 8.16276 3.26158 8.24621 3.5527 8.28568C3.83314 8.3232 4.18993 8.3232 4.63211 8.3232H5.63809C6.08027 8.3232 6.43706 8.3232 6.7175 8.28568C7.00862 8.24621 7.25381 8.16276 7.44854 7.96803C7.64327 7.7733 7.72672 7.52812 7.76618 7.237C7.80371 6.95655 7.80371 6.59977 7.80371 6.15759V4.50467C7.80371 4.06249 7.80371 3.7057 7.76618 3.42526C7.72672 3.13414 7.64327 2.88895 7.44854 2.69422C7.27678 2.52278 7.06588 2.43706 6.81875 2.39275C6.77368 2.10729 6.6282 1.8473 6.4085 1.65956C6.18879 1.47182 5.90929 1.36866 5.6203 1.36865ZM6.30929 2.34585C6.2601 2.20223 6.16724 2.07758 6.04369 1.98936C5.92015 1.90114 5.77211 1.85376 5.6203 1.85385H4.32643C3.70958 1.85385 3.27161 1.8545 2.93876 1.89914C2.61367 1.94281 2.42606 2.02497 2.28924 2.16179C2.15241 2.29862 2.07025 2.48623 2.02658 2.81164C1.98194 3.14416 1.98129 3.58214 1.98129 4.19899V6.1398C1.9812 6.2916 2.02858 6.43964 2.1168 6.56319C2.20502 6.68673 2.32967 6.77959 2.47329 6.82878C2.4665 6.63146 2.4665 6.40827 2.4665 6.15759V4.50467C2.4665 4.06249 2.4665 3.7057 2.50434 3.42526C2.54316 3.13414 2.62726 2.88895 2.82166 2.69422C3.01639 2.49949 3.26158 2.41604 3.5527 2.3769C3.83314 2.33905 4.18993 2.33905 4.63211 2.33905H5.63809C5.88878 2.33905 6.11197 2.33905 6.30929 2.34585ZM3.16454 3.03774C3.25414 2.94814 3.37964 2.88992 3.61739 2.8579C3.86129 2.82523 4.1854 2.82458 4.64958 2.82458H5.61998C6.08415 2.82458 6.40794 2.82523 6.65249 2.8579C6.88991 2.88992 7.01542 2.94847 7.10502 3.03774C7.19462 3.12734 7.25284 3.25285 7.28486 3.4906C7.31753 3.73449 7.31818 4.05861 7.31818 4.52278V6.14012C7.31818 6.60429 7.31753 6.92809 7.28486 7.17263C7.25284 7.41005 7.19429 7.53556 7.10502 7.62516C7.01542 7.71476 6.88991 7.77298 6.65216 7.80501C6.40794 7.83768 6.08415 7.83832 5.61998 7.83832H4.64958C4.1854 7.83832 3.86129 7.83768 3.61707 7.80501C3.37964 7.77298 3.25414 7.71443 3.16454 7.62516C3.07494 7.53556 3.01671 7.41005 2.98469 7.1723C2.95202 6.92808 2.95137 6.60429 2.95137 6.14012V4.52278C2.95137 4.05861 2.95202 3.73449 2.98469 3.49027C3.01671 3.25285 3.07526 3.12734 3.16454 3.03774Z" fill="black" />
                  </g>
                  <defs>
                    <clipPath id="clip0_1664_2612">
                      <rect width="7.76322" height="7.76322" fill="black" transform="translate(0.767578 0.964233)" />
                    </clipPath>
                  </defs>
                </svg>
                {showCopiedTextImpression ? <span className="ml-2 mr-1.5 text-sm text-blue-900">Copied !!</span> : <span className="text-sm">Impression</span>}
              </button> */}

             


              <button class="bg-white border border-red-500 text-black font-semibold py-2 px-4 rounded inline-flex items-center" onClick={handleOnClearClick}>
                <svg width="24" height="24" viewBox="0 0 28 23" fill="none" xmlns="http://www.w3.org/2000/svg"  >
                  <circle cx="11.9" cy="10.7092" r="10.0408" stroke="black" stroke-width="1.2551" />
                  <path d="M16.8673 7.20116L15.9824 6.31631L12.4744 9.82433L8.96639 6.31631L8.08154 7.20116L11.5896 10.7092L8.08154 14.2172L8.96639 15.102L12.4744 11.594L15.9824 15.102L16.8673 14.2172L13.3592 10.7092L16.8673 7.20116Z" fill="black" />
                </svg>
                <span className="text-sm font-normal">Clear</span>
              </button>
              <button class=" bg-white border border-[#09947F] font-semibold py-2 px-3 rounded inline-flex items-center"                
               >
                <TbClick />
                <span className="ml-2 mr-1.5 text-sm text-black font-normal " onClick={handleReport}> Submit</span>
              </button>
              <div>
                <div onClick={handleToggleDictateTooltip}>
                  <Augnito sendMessageStream={handleStreamText} />
                </div>


                {(!whisperState && !startwriting) && (
                  <div className="bottom shadow-xl rounded-xl z-[99] md:absolute right-[1em] w-[13%] absolute">
                    <Dictate />
                  </div>
                )}

                {startwriting && (
                  <div className="bottom shadow-xl rounded-xl z-[99] md:absolute md:right-[4em] lg:right-[1em] w-[13%] hidden">
                    <Dictate />
                  </div>
                )}






                {/* {augnitoStateRender && augnitoEditorState &&(
        <div className='hidden'>
        <Dictate/>
        </div>
      )} */}
              </div>
              {/* <div className=' absolute shadow-lg right-20'>
              <Dictate sendMessageStream={augnitoTextValue} ></Dictate>
              </div> */}
            </div>
          </div>
        </div>

        <div id="editor">
          <ReactQuill
            ref={quillRef}
            value={quillRef.current ? quillRef.current.getEditor().root.innerHTML : ''}
            modules={{
              toolbar: toolbarOptions,
            }}
            onFocus={handleEditorFocus}
          />
          {isMentionActive && (
            <div
              style={{
                position: 'absolute',
                left: formPosition.left,
                top: formPosition.top,
                backgroundColor: 'white',
                border: '1px solid #ccc',
                padding: '8px',
              }}
            >
              {pathologyForSearchRef.current.pathologyForSearch.slice(0, 5).map((label, index) => (
                <div key={index} style={{ marginBottom: '8px' }}>
                  <button htmlFor={label} style={{ paddingLeft: '5px', cursor: 'pointer' }} onClick={(e) => { hamdleSelectFromMention(e.target.innerText) }}>
                    {label}
                  </button>
                </div>
              ))}
            </div>
          )}
          {showForm && (variableType === 'multiple choice' ? (
            <form
              style={{
                position: 'absolute',
                left: formPosition.left,
                top: formPosition.top,
                backgroundColor: 'white',
                border: '1px solid #ccc',
                padding: '8px',
              }}
              onSubmit={(e) => { handleMultipleSelect(e); logColorRanges(); }}
            >
              {getOptionFromReportContents(reportContents, selectedPathologyOnClick, currentLabel)?.map((label, index) => (
                <div key={index} style={{ marginBottom: '8px' }}>
                  <button type="button" onClick={() => { setShowForm(true); }}>
                    <label htmlFor={label} className='pr-4'>
                      <input type="checkbox" className='mr-2' id={label} name={label} value={label} />
                      {label}
                    </label>
                  </button>
                </div>
              ))}
              <button style={{ border: 'none', float: 'right', backgroundColor: 'white', cursor: 'pointer' }} >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -2 20 20" fill="currentColor" className="h-5 w-5 rotate-90 transform">
                  <path fill="black" d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z"></path>
                </svg>
              </button>
            </form>)
            : variableType === 'single choice' ? (<div
              style={{
                position: 'absolute',
                left: formPosition.left,
                top: formPosition.top,
                backgroundColor: 'white',
                border: '1px solid #ccc',
                padding: '8px',
              }}
            >
              {getOptionFromReportContents(reportContents, selectedPathologyOnClick, currentLabel)?.map((label, index) => (
                <div key={index} style={{ marginBottom: '8px' }}>
                  <button htmlFor={label} style={{ paddingLeft: '5px', cursor: 'pointer' }} onClick={(e) => { handleLabelSelect(e.target.innerText); logColorRanges(); }}>
                    {label}
                  </button>
                </div>
              ))}
            </div>
            ) : variableType === 'input box' && (
              <div
                style={{
                  position: 'absolute',
                  left: formPosition.left,
                  top: formPosition.top,
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  padding: '4px',
                }}
              >
                <input
                  type="text"
                  placeholder="Enter size"
                  value={sizeInputDictate}
                  style={{
                    width: '100px',
                    outline: 'none',
                    border: 'none',
                    '&:focus': {
                      border: '1px solid #ccc',
                    },
                  }}
                  autoFocus
                  onChange={(e) => dispatch(setSizeInput({ 'action': 'reset', 'text': e.target.value }))}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      setIsOptionClicked(false)
                      handleLabelSelect(e.target.value)
                      logColorRanges();
                      dispatch(setSizeInput({ 'action': 'reset', 'text': '' }))

                    }
                  }}
                />
              </div>
            )
          )}
        </div>
      </div>

    </div>
  );
}

export default Editor;
